export default __webpack_public_path__ + "static/media/i-like-i-wish-what-if.f9fc293c.svg";